import { RecipientRequestType } from '@/types/vendorVaultTypes';
import { useQuery } from '@tanstack/react-query';
import { loadRequestVerification, VENDOR_VAULT_QUERY_KEYS } from '../api/api';
import { IdVerificationRecordDialog } from '@/bundle/shared/components/IdVerificationRecordDialog/IdVerificationRecordDialog';

type VendorVaultVerificationRecordModalType = {
  isOpen: boolean;
  request: RecipientRequestType;
  onClose: () => void;
};

export const VendorVaultVerificationRecordModal = ({
  isOpen,
  request,
  onClose,
}: VendorVaultVerificationRecordModalType) => {
  const { data, isPending } = useQuery({
    queryKey: [VENDOR_VAULT_QUERY_KEYS.verification, request.id],
    queryFn: () => loadRequestVerification(request.id),
  });
  const record = data?.body;

  return <IdVerificationRecordDialog isOpen={isOpen} onClose={onClose} record={record} isLoading={isPending} />;
};
